var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlovenia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "85.333 85.333 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.048318
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 85.333,
    width: 24,
    height: 17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 91,
    width: 24,
    height: 5.6667,
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 96.666,
    width: 24,
    height: 5.6667,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.283 90.876v0.73897c0 1.6974-2.087 2.2175-2.087 2.2175s-2.087-0.51997-2.087-2.2175v-0.73897l-0.0068-2.2008 4.1739-0.01325z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.283 90.876v0.73897c0 1.6974-2.087 2.2175-2.087 2.2175s-2.087-0.51997-2.087-2.2175v-0.73897l-0.0068-2.2008 4.1739-0.01325z",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.283 90.876v0.73897c0 1.6974-2.087 2.2175-2.087 2.2175s-2.087-0.51997-2.087-2.2175v-0.73897l0.696 0.73897 1.391-1.1087 1.3915 1.1087z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovenia);
export default __webpack_public_path__ + "static/media/slovenia.813521ec48cd59fdc6ed053dcbaaa8e7.svg";
export { ForwardRef as ReactComponent };